import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Button, Input } from 'ui/styled';
import { selectAgents, useContactStore } from 'stores/nic/stores/contactStore';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { useAgentData } from 'pages/NIC/components/Agents/hooks/useAgentData';
import { useNicService } from 'stores/nic/useNicService';
import { AgentsWrapper } from './styled';
var AgentsTab = function () {
    var agents = useContactStore(selectAgents);
    var calls = useCallStore(selectCalls);
    var _a = useCallStore(), setCalls = _a.setCalls, setShowAdditionalDirectory = _a.setShowAdditionalDirectory;
    var _b = useAgentData(), getAgentFullName = _b.getAgentFullName, isAgentAvailable = _b.isAgentAvailable, getAgentId = _b.getAgentId;
    var holdCurrentAndConsultAgent = useNicService().holdCurrentAndConsultAgent;
    var currentCallIndex = calls.findIndex(function (c) { return c.call !== null; });
    var transferCallIndex = calls.length;
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var agentItems = useMemo(function () {
        return agents.filter(function (agent) {
            if (!isAgentAvailable(agent))
                return false;
            if (!searchValue)
                return true;
            return getAgentFullName(agent)
                .toLowerCase()
                .includes(searchValue.toLowerCase());
        });
    }, [agents, isAgentAvailable, searchValue, getAgentFullName]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { paddingBottom: 8 }, children: _jsx(Input, { placeholder: "Search agents", value: searchValue, onChange: function (e) { return setSearchValue(e.target.value); } }) }), _jsx("div", { style: { overflowY: 'auto', maxHeight: 190 }, children: agentItems.length ? (agentItems.map(function (agent) { return (_jsxs(AgentsWrapper, { children: [_jsx("div", { children: getAgentFullName(agent) }), _jsx(Button, { onClick: function () {
                                setShowAdditionalDirectory(false);
                                holdCurrentAndConsultAgent(getAgentId(agent), currentCallIndex);
                                setCalls({ index: transferCallIndex, agentInfo: agent });
                            }, children: "Call" })] }, getAgentId(agent))); })) : (_jsx("div", { style: { padding: '8px 0 8px 8px' }, children: "No available agents" })) })] }));
};
export default AgentsTab;
